import { cn } from '@/lib/utils';

interface MarqueeProps {
  className?: string;
  // CSSProperties plus the custom properties consumers set (--duration, --gap).
  style?: React.CSSProperties & { [key: `--${string}`]: string | number };
  reverse?: boolean;
  pauseOnHover?: boolean;
  children?: React.ReactNode;
  vertical?: boolean;
  repeat?: number;
  [key: string]: unknown;
}

const trackStyle = (
  reverse: boolean,
  vertical: boolean,
): React.CSSProperties => ({
  display: 'flex',
  flexShrink: 0,
  gap: 'var(--gap)',
  flexDirection: vertical ? 'column' : 'row',
  animation: `${vertical ? 'marquee-vertical' : 'marquee'} var(--duration) infinite linear`,
  animationDirection: reverse ? 'reverse' : 'normal',
});

export function Marquee({
  className,
  style,
  reverse = false,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  ...props
}: MarqueeProps) {
  return (
    <div
      {...props}
      className={cn('marquee-root', className)}
      style={{
        display: 'flex',
        overflow: 'hidden',
        padding: '0.5rem',
        gap: 'var(--gap)',
        flexDirection: vertical ? 'column' : 'row',
        ...style,
      }}
    >
      {Array(repeat)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className={
              pauseOnHover
                ? 'marquee-track marquee-track--pause-on-hover'
                : 'marquee-track'
            }
            style={trackStyle(reverse, vertical)}
          >
            {children}
          </div>
        ))}
    </div>
  );
}
